import { IconBox } from '@tabler/icons-react'

import { BaseBlockConfig, Field, TypeOption } from '../_BaseBlockConfig'

import { SwmsPlantDisplayBlock } from '@/modules/templates/templateRenderer/DisplayBlocks/SwmsPlantDisplayBlock'
import { SWMSPlantDisplayBlock } from '@/modules/templates/types/blueprint'

import { TemplateType } from 'types/api.graphql'

class Config extends BaseBlockConfig<SWMSPlantDisplayBlock> {
  public kind = 'display' as const
  public type = 'swmsPlant' as const

  public blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'SWMS - Plant',
    icon: IconBox,
    exclusiveTemplateTypes: [TemplateType.Swms],
  }

  public blockFieldsConfig: Field[] = []

  public mapFormValueToBlock(
    block: SWMSPlantDisplayBlock
  ): SWMSPlantDisplayBlock {
    return block
  }
  public renderBlock(block: SWMSPlantDisplayBlock): React.ReactNode {
    return <SwmsPlantDisplayBlock block={block} />
  }
}

export const SwmsPlantDisplayBlockConfig = new Config()
